import React from 'react'
import PropTypes from 'prop-types'

const PlusIcon = ({ size = '24', color = 'white', opacity }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      opacity={opacity}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M16.9693 11.8792H8.03534" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M12.5024 16.2723L12.5024 7.48608"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.5023 22.862C18.67 22.862 23.6698 17.9449 23.6698 11.8792C23.6698 5.81363 18.67 0.896484 12.5023 0.896484C6.33473 0.896484 1.3349 5.81363 1.3349 11.8792C1.3349 17.9449 6.33473 22.862 12.5023 22.862Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default React.memo(PlusIcon)
PlusIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
}
